export const getUser = ({signInState}) => signInState.user;